/**
 * @file utils.js
 * @author Geoffrey Pursell
 * @desc Contains miscellaneous useful bits of code that are used
 * elsewhere all over the place, or just flat-out doesn't belong
 * anywhere else.

*/

/* global Spinner, require */

define('cardboard/util',[
    // libraries
    "jquery", "underscore", "underscore.string", "backbone", "velocity", "rsvp",

    //app modules
    "colors"

    // templates

],
    function ($, _, _s, Backbone, Velocity, RSVP,
        Colors) {

        console.log("MODULE: cardboard/util");

        var Promise = RSVP.Promise;

        /**
         * @exports cardboard/util
         * @desc Contains miscellaneous useful bits of code that are used
         * elsewhere all over the place, or just flat-out doesn't belong
         * anywhere else.
         */
        var Util = {
            /** function that can be mixed in to vairous objects to
             * implement Backbone's declarative event-binding pattern on
             * any object. */
            attachGlobalEvents: function () {
                _(this.globalEvents).each(_.bind(function (value, key) {
                    Backbone.on(key, this[value], this);
                }, this));
            },
            stopListeningToGlobalEvents: function () {
                _(this.globalEvents).each(_.bind(function (value, key) {
                    Backbone.off(key, this[value], this);
                }, this));
            },

            /** the inheritance pattern we favor: it's fully prototypical,
             * fast, and lets you use "normal" constructor functions
             * together with object hashes. See the Object.create polyfill
             * below */
            inherit: function (soup, sub, obj) {
                sub.prototype = Object.create(soup.prototype);
                _(sub.prototype).extend(obj);
            },

            isFullyVisible: function (e) {
                var $el = $(e),
                    vph = $(window).height(), // Viewport Height
                    st = $(window).scrollTop(), // Scroll Top
                    sb = (st + vph), // Scroll bottom (viewport bottom edge)
                    et = $el.offset().top, // Top of element
                    eb = et + $(e).height(); // bottom of element

                return ((et >= st) && (eb <= sb));
            },

            /** test to see if an element is fully visible
             * @returns a truthy page-y-coordinate to scroll to for the bottom of
             * the element to become fully visible, as long as it doesn't obscure
             * the top edge of the element. false otherwise */
            bottomObscuredByScroll: function (e) {
                var $el = $(e),
                    vph = $(window).height(), // Viewport Height
                    st = $(window).scrollTop(), // Scroll Top
                    sb = (st + vph), // Scroll bottom (viewport bottom edge)
                    et = $el.offset().top, // Top of element
                    eb = et + $(e).height(), // bottom of element
                    // obscuredPixelsAbove = (st - et),
                    obscuredPixelsBelow = (eb - sb);

                if (eb >= sb) {
                    // ok, element bottom is obscured by viewport, let's
                    // fix it
                    var scrollTarget = (st + obscuredPixelsBelow);
                    if (scrollTarget > et) {
                        // let's not tell anyone to scroll the top edge of
                        // the element out of view, though
                        return et;
                    }
                    return scrollTarget;
                }

                // it wasn't obscured! carry on
                return false;
            },

            /** smoothly scroll the page until the top of an element is (almost)
             * aligned with the top edge of the viewport */
            scrollToTop: function (element) {
                var $element = $(element),
                    topEdge = $element.offset().top,
                    padding = 3;

                //return Util.scrollToPixel(topEdge - padding);
            },

            /** scroll the page to the requested pixel y-coordinate
             * @returns {Promise} a promise that resolves when the animation is
             * finished */
            scrollToPixel: function (pixel) {
                // new implementation using velocity for speed
                // return Util.scrollToElement(document.body, -pixel);
            },
            // scrollToPixel: function (y) {
            //  var htmlAndBody = $("html,body");

            //  // set a global flag to tell any other part of the app that we're
            //  // scrolling, in case something might need to be postponed until
            //  // afterwards
            //  window.scrolling = true;

            //  // right now, we do this the jQuery way.
            //  htmlAndBody.animate({scrollTop: y}, 500, "easeOutQuint", function () {
            //      window.scrolling = false;
            //  });
            //  // someday there should be super-efficient way to do
            //  // this with CSS transitions.
            // },

            /** scroll the page to the edge of the given element. this aims to be
             * faster than scrollToPixel because of the velocity animation
             * framework.
             * @returns {Promise} a promise that resolves when the animation is
             * finished */
            scrollToElement: function (el, customFudge) {
                var $el = $(el),
                    $mainHeader = $("#mainHeader"),
                    fudge = customFudge || 10,
                    offset = fudge;

                if (!$mainHeader.is(".ui-fixed-hidden")) {
                    offset = -$mainHeader.outerHeight() - fudge;
                }

                // set a global flag to tell any other part of the app that we're
                // scrolling, in case something might need to be postponed until
                // afterwards
                window.scrolling = true;

                // until velocity.js supports animation promises, we'll roll our
                // own, wrapping its callback.
                var resolvePromise,
                    promise = new Promise(function (resolve /*, reject*/) {
                        resolvePromise = function () {
                            resolve();
                        };
                    });

                // do it
                $el.velocity("scroll", {
                    duration: 500,
                    easing: "easeOutQuint",
                    mobileHA: false,
                    offset: offset,
                    complete: function () {
                        window.scrolling = false;
                        resolvePromise();
                    }
                });

                return promise;
            },

            /** Return the current text of the title element  */
            getTitleText: function () {
                return $.trim($('title').text());
            },

            /** debugging function, to show large chunks of JSON */
            inspectJSON: function (obj, name) {
                require(["highlight", "hogan"], function (Highlight, Hogan) {
                    try {
                        // ick, but whatever
                        if (_s.contains(window.navigator.userAgent, "obile")) {
                            return;
                        }

                        var jsonString = JSON.stringify(obj, function (key, value) {
                            // censoring function, to avoid nasty fails
                            // https://developer.mozilla.org/en-US/docs/Using_native_JSON
                            if (value instanceof Element) {
                                return undefined;
                            }
                            return value;
                        }, 4),
                            win = window.open(null, name),
                            doc,
                            html = "<html><head>" + "  <title>{{title}}</title>" + "  <link rel='stylesheet' href='http://yandex.st/highlightjs/7.3/styles/default.min.css' />" + "</head><body>" + "  <pre><code>{{{json}}}</code></pre>" + "</body></html>",
                            displayJSON;

                        // syntax-highlight the JSON, if it won't take too long.
                        if (jsonString.length < 160000) {
                            displayJSON = Highlight.highlightAuto(jsonString).value;
                        } else {
                            displayJSON = jsonString;
                        }

                        if (win) {
                            doc = win.document;
                            doc.open("text/html");
                            doc.writeln(Hogan.compile(html).render({
                                title: name,
                                json: displayJSON
                            }));

                            doc.close();
                        }
                    } catch (err) {
                        console.log("ERROR.");
                        console.log(err);
                    }
                });
            },

            /** evaluate a pane's condition against the current settings
             * @param {Object} condition the condition from the pane config
             * @param {Object} currentSettings a hash of the current filter settings
             * @returns {Boolean} the truth value of the condition */
            evaluateFilterCondition: function (condition, data) {
                // GTP 6/19/2014: add a new style of filter condition wherein we're
                // passed a function with one parameter; we pass in the data we were
                // given and the function is expected to make some determination
                // based on the passed in data and return a boolean (or other
                // truthy/falsy value)
                // console.log(condition);
                //   console.log(data);
                if (_.isFunction(condition)) {

                    try {
                        return condition(data);
                    } catch (err) {
                        return false;
                    }
                } else {

                    var subject = (condition.filter || condition.valuePath || condition.value),
                        currentSetting = Util.Data.getDataFromPath(data, subject);

                    if (_.isUndefined(currentSetting)) {
                        console.log("WARNING: couldn't find condition value environment at " + subject);
                        console.log("environment:");
                        console.log(data);
                        if (!data.meta) {
                            data.meta = "Data is not available";
                       /*      if (location.hash.indexOf("mySchool") > -1) {
                                location.hash = "#mySchool/orgId--999999000000__groupType--state__p--3";
                                setTimeout(function () {
                                    Backbone.trigger("reportSet");
                                }, 500);
                                setTimeout(function () {
                                    $(window).trigger('hashchange');
                                }, 3000);
                            } */
                        }
                    }

                    if (_(condition).has("is")) {
                        return (currentSetting === condition.is);
                    } else if (_(condition).has("isNot")) {
                        return (currentSetting !== condition.isNot);
                    } else {
                        throw "missing condition in when blob in pane config object";
                    }
                }
            },

            UI: {
                /** whip a mask on some element, disable any form
                 * controls, and dim its contents */
                maskForLoading: function (el, useSpinner) {
                    var $el = $(el).addClass("dimmed");

                    if (useSpinner === false) {
                        return;
                    }

                    var elementHeight = $el.outerHeight(),
                        spinner = $el.data("spinner");

                    // only mask if it's not already masked
                    if (elementHeight > 50 && !spinner) {
                        spinner = new Spinner({
                            lines: 13, // The number of lines to draw
                            length: 11, // The length of each line
                            width: 9, // The line thickness
                            radius: 30, // The radius of the inner circle
                            corners: 1, // Corner roundness (0..1)
                            rotate: 0, // The rotation offset
                            direction: 1, // 1: clockwise, -1: counterclockwise
                            color: "#000", // #rgb or #rrggbbnnnn
                            speed: 1, // Rounds per second
                            trail: 60, // Afterglow percentage
                            shadow: false, // Whether to render a shadow
                            hwaccel: true, // Whether to use hardware acceleration
                            className: "spinner", // The CSS class to assign to the spinner
                            zIndex: 5 // The z-index (defaults to 2000000000)
                        });

                        // TODO: properly handle form elements that were
                        // disabled before we found them.

                        $el.data("spinner", spinner);
                        spinner.spin($el[0]);
                    }
                },
                unmaskForLoading: function (el) {
                    var $el = $(el).removeClass("dimmed"),
                        spinner = $el.data("spinner");

                    if (spinner) {
                        $el.data("spinner", null);
                        spinner.stop();
                    }
                },
                showSmallSpinner: function (el) {
                    var $el = $(el),
                        opts = {
                            lines: 11, // The number of lines to draw
                            length: 4, // The length of each line
                            width: 2, // The line thickness
                            radius: 5, // The radius of the inner circle
                            corners: 1, // Corner roundness (0..1)
                            rotate: 0, // The rotation offset
                            direction: 1, // 1: clockwise, -1: counterclockwise
                            color: "#000", // #rgb or #rrggbb
                            speed: 1, // Rounds per second
                            trail: 60, // Afterglow percentage
                            shadow: false, // Whether to render a shadow
                            hwaccel: false, // Whether to use hardware acceleration
                            className: "spinner", // The CSS class to assign to the spinner
                            zIndex: 2e9, // The z-index (defaults to 2000000000)
                            top: "auto", // Top position relative to parent in px
                            left: "auto" // Left position relative to parent in px
                        },
                        spinner = new Spinner(opts).spin(el);

                    $el.data("spinner", spinner);
                    spinner.spin($el[0]);
                },
                destroySmallSpinner: function (el) {
                    var $el = $(el),
                        spinner = $el.data("spinner");

                    if (spinner) {
                        spinner.stop();
                    }
                    $el.data("spinner", null);
                },
                // GENERIC MASKING
                // depends on .mask class in CSS
                maskElement: function (el) {
                    var $el = $(el),
                        $mask = $("<div class='mask'></div>");
                    $el.append($mask);
                    _.delay(function () {
                        $mask.addClass("dimmed");
                    }, 10);
                    // $mask.addClass("dimmed");
                },
                unmaskElement: function (el) {
                    var $el = $(el),
                        $mask = $el.children(".mask");
                    $mask.removeClass("dimmed");
                    _.delay(function () {
                        $mask.remove();
                    }, 10);
                }
            },

            /** @namespace */
            Data: {
                popEach: function (arr, iterator) {
                    /* jshint boss:true */
                    var current;
                    while ((current = arr.pop())) {
                        iterator(current);
                    }
                },

                isEmptyObject: function (value) {
                    return _(value).isObject() && _(value).isEmpty() &&
                        !_(value).isArray() && !_(value).isFunction();
                },

                isHashOfObjects: function (collection) {
                    return _(collection).every(function (value) {
                        return (!_.isObject(value));
                    });
                },

                /**
                 * @param {Object | Array} thing a JS object or array that
                 * describes the structure of an output JS object along with
                 * where to get values from a flat-ish JSON blob. it's meant
                 * to be recursive. */

                buildJSON: function (outputTemplate, sourceData) {
                    var output;

                    if (!outputTemplate || _.isEmpty(outputTemplate) || !sourceData) {
                        // if we have a falsy or empty outputTemplate,
                        // just pass through the original data
                        return sourceData;
                    } else if (_.isArray(outputTemplate)) {
                        if (outputTemplate.length === 1) {
                            // a 1-length array in the output template tells us
                            // that this blob is supposed to repeat in its
                            // context. because the output template can't tell us
                            // how many items there are, but the input data can,
                            // we have to shift to input-directed processing
                            return _(sourceData).map(function (inputRow) {
                                return Util.Data.buildJSON(outputTemplate[0], inputRow);
                            }).value();
                        } else {
                            // it's an array with an intended length, put there by
                            // the template author. process every row in the
                            // template, but reject empty objects
                            output = [];
                            _(outputTemplate).each(function (outputTemplateRow) {
                                var value = Util.Data.buildJSON(outputTemplateRow, sourceData);
                                if (!this.isEmptyObject(value)) {
                                    output.push(value);
                                }
                            }.bind(this));
                            return output;
                        }
                    } else if (_.isObject(outputTemplate)) {
                        // outputTemplate is an object/hash: build and return one
                        // with real values.
                        output = {};
                        _(outputTemplate).each(function (templateValue, outputFieldName) {
                            // is this thing a special object that gives us an
                            // input field name and a value map?
                            if (_.isObject(templateValue) && _(templateValue).has("_inputFieldName")) {
                                var inputFieldName = templateValue._inputFieldName,
                                    mappedValue, inputValue = sourceData[inputFieldName];

                                if (!inputFieldName) {
                                    return;
                                }
                                if (templateValue._valueMap) {
                                    // It's a bona fide VALUE-MAPPED FIELD
                                    // just as in the simplest case below: return a
                                    // simple value (only mapped), easy
                                    mappedValue = templateValue._valueMap[inputValue];
                                    output[outputFieldName] = (!_.isUndefined(mappedValue) ? mappedValue : inputValue);
                                } else {
                                    // _inputFieldName but no _valueMap?! well, okay
                                    output[outputFieldName] = inputValue;
                                }
                            } else {
                                // nah, it's a normal object, descend into it as
                                // usual.  HOWEVER: if the template says an output
                                // field should stay null, do that
                                var outputValue = (templateValue === null) ? undefined :
                                    Util.Data.buildJSON(templateValue, sourceData);

                                if (!_.isUndefined(outputValue) && !this.isEmptyObject(outputValue)) {
                                    output[outputFieldName] = outputValue;
                                }
                            }
                        }.bind(this));
                        return output;
                    } else {
                        // return a simple value, that's easy!
                        return sourceData[outputTemplate];
                    }
                },

                /**
                 * @param {Object | Array} keyMap a map of input keys to output keys
                 * @param {Object | Array} inputData the JS object or array whose
                 * keys are to be mapped.  feed an object into it, and it will
                 * change some of the key names, based on the key map. */
                mapKeys: function (keyMap, inputData) {
                    var output;

                    if (!keyMap || _.isEmpty(keyMap) || !inputData) {
                        // if we have a falsy or empty outputTemplate,
                        // just pass through the original data
                        return inputData;
                    } else if (_.isArray(inputData)) {
                        return _(inputData).map(function (arrayValue) {
                            return Util.Data.mapKeys(keyMap, arrayValue);
                        }).value();
                    } else if (_.isObject(inputData)) {
                        // this is a JS object: map the key and work on the value.
                        output = {};
                        _(inputData).each(function (objectValue, originalKey) {
                            var outputKey = (keyMap[originalKey] ? keyMap[originalKey] : originalKey);
                            output[outputKey] = Util.Data.mapKeys(keyMap, objectValue);
                        });
                        return output;
                    } else {
                        // return a simple value, that's easy!
                        return inputData;
                    }
                },

                /** takes a "path" in dot notation to extract a piece of data from a
                 * JSON object
                 * @param {String} allData the whole data object from which to
                 * extract the part we're interested in
                 * @param {String} path the path though the "whole" data object to
                 * the data fragment we're interested in
                 * @example "nestedObject.specificThing"
                 * @returns the data you asked for, if it exists. if not,
                 * undefined */
                getDataFromPath: function (allData, path) {
                    var requestedData;
                    path = $.trim(path);
                    if (!path || path === "") {
                        return undefined;
                    }

                    try {
                        /* jshint evil:true */
                        requestedData = eval("allData" + (path[0] === "[" ? "" : ".") + path);
                        return requestedData;
                    } catch (err) {
                        return undefined;
                    }
                },

                setDataAtPath: function (allData, path, value) {
                    path = $.trim(path);
                    if (!path || path === "") {
                        return allData;
                    }

                    try {
                        /* jshint evil: true, unused: false */
                        var evalString = "allData" + (path[0] === "[" ? "" : ".") + path + " = value";
                        eval(evalString);

                        return allData;
                    } catch (err) {
                        return allData;
                    }
                },

                /** take a data source info object (such as are found in every
                 * report plugin, and in dataSources.js) and returns a correctly
                 * instatiated data model object. Frees other parts of the code from
                 * caring about whether to use the model object given by the
                 * WebFOCUS adapter or the default.
                 * @param {Object} dataSourceInfo, The data source info object,
                 * maybe with a WebFocus adapter, maybe not, we'll figure it out
                 * @param {Array} initialData, An array of default data with which
                 * to initialize the data source
                 */
                instantiateSource: function (dataSourceInfo, initialData) {
                    var data = (initialData ? initialData : []),
                        ModelType = (dataSourceInfo.webFocusAdapter &&
                            dataSourceInfo.webFocusAdapter.modelType ?
                            dataSourceInfo.webFocusAdapter.modelType :
                            dataSourceInfo.modelType);

                    return new ModelType(data, dataSourceInfo);
                },

                // here are the regexes used by prettifyName; we put them here so we
                // don't have to compile them every time prettifyName() is
                // executed. This will save quite a bit of execultion time at
                // application startup.
                Regex: {
                    capitalizer: /^(and|f?or|of|the)$/i,
                    hyphenMatcher: /[\-/]/,
                    acronymMatcher: /^(([a-z]\.)+|ne|se|nw|sw|mn|jj|aalc|doc|aioic|aeoa|spclc|isd|esy|acgc|aap|afsa|alp|abe|esl|oic|clues|lna|mctc|more|mrved|voa|access|thinkself)$/i,
                    scottishHandler: /^mc([a-z]+)$/i,
                    districtMatcher: /\bdist(\.|\b)/gi,
                    schoolMatcher1: /\bsch(\.|\b)/gi,
                    schoolMatcher2: /\bsc\b/gi,
                    academyMatcher: /\b(ac?dmy|acad)\b/gi,
                    centerMatcher: /\bcntr(\.|\b)/gi,
                    saintMatcher: /\bst\b/gi,
                    elementaryMatcher: /\bel\./gi,
                    parkMatcher: /\bpk\b/gi,
                    doublePeriodMatcher: /\.\./g,
                    badlySpacedAcronymMatcher: /\b(([a-z]\.)+)([a-z]{2,})\b/gi
                },

                /**
                 * makes an entity name readable, even from the old DB
                 * @param {String} name An ugly entity name
                 * @returns {String} The pretty version of the ugly entity name
                 */
                prettifyName: function (name) {

                    // utility functions
                    function capitalize(word) {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }

                    function fixWord(word) {
                        // make this word lowercase
                        var fixed = word.toLowerCase(),
                            match;
                        // capitalize the first letter
                        if (!fixed.match(Util.Data.Regex.capitalizer)) {
                            fixed = capitalize(fixed);
                        }
                        // if it's hyphenated, do each segment, treating "-"
                        // as the word boundary
                        if ((match = fixed.match(Util.Data.Regex.hyphenMatcher))) {
                            fixed = fixWords(fixed, match[0]);
                        }
                        // if it's an acronym, UPPERCASE the whole thing
                        if (fixed.match(Util.Data.Regex.acronymMatcher)) {
                            fixed = fixed.toUpperCase();
                        }
                        // Scottish handling
                        match = fixed.match(Util.Data.Regex.scottishHandler);
                        if (match) {
                            fixed = "Mc" + fixWord(match[1]);
                        }

                        return fixed;
                    }

                    function fixWords(str, separator) {
                        return _(str.split(separator)).map(fixWord).join(separator);
                    }

                    // expand some ugly abbreviations
                    var pretty = name.replace(Util.Data.Regex.districtMatcher, "DISTRICT");
                    pretty = pretty.replace(Util.Data.Regex.schoolMatcher1, "SCHOOL");
                    pretty = pretty.replace(Util.Data.Regex.schoolMatcher2, "SCHOOL");
                    pretty = pretty.replace(Util.Data.Regex.academyMatcher, "ACADEMY");
                    pretty = pretty.replace(Util.Data.Regex.saintMatcher, "ST.");
                    pretty = pretty.replace(Util.Data.Regex.elementaryMatcher, "ELEMENTARY");
                    pretty = pretty.replace(Util.Data.Regex.parkMatcher, "PARK");
                    pretty = pretty.replace(Util.Data.Regex.centerMatcher, "CENTER");

                    // fix double periods
                    pretty = pretty.replace(Util.Data.Regex.doublePeriodMatcher, ".");

                    // fix badly-spaced acronyms
                    pretty = pretty.replace(Util.Data.Regex.badlySpacedAcronymMatcher, "$1 $3");

                    // split into words and do some real proper nouns
                    return fixWords(pretty, " ");
                },
                /** @deprecated */
                parseWFOrgID: function (qs) {
                    // OPTIMIZATION: use substring intead of regex
                    // var re = /^(\d{4})(\d{2})(\d{3})/;
                    // var partsArray = re.exec(qs);
                    var partsArray = [
                        qs.substring(0, 9),
                        qs.substring(0, 4),
                        qs.substring(4, 6),
                        qs.substring(6, 9)
                    ];
                    var parts = {
                        wfOrgId: partsArray[0],
                        districtNumber: parseInt(partsArray[1], 10),
                        districtType: parseInt(partsArray[2], 10),
                        schoolNumber: parseInt(partsArray[3], 10)
                    };

                    return parts;
                },

                /** Represents a standard MDE OrgID.  WARNING: this currently can
                 * only take WebFOCUS Org IDs. We plan to support parsing proper MDE Org IDs
                 * in the future, but we currently have no need.
                 * @class OrgID
                 * @param {Object} setup An options hash.
                 * @param {String} setup.wfOrgID a well-formed WebFOCUS-formatted org id. This is different from the standard format.
                 * @param {Number} setup.districtNumber The district number of the organization
                 * @param {Number} setup.districtType The numeric type of the organization's district
                 * @param {Number} setup.schoolNumber The numeric type of the school
                 */
                OrgID: function (setup) {

                    // init setup
                    if (setup.wfOrgID) {
                        this.parseWFOrgID(setup.wfOrgID);
                    }
                    if (setup.districtNumber) {
                        this.districtNumber = setup.districtNumber;
                    }
                    if (setup.districtType) {
                        this.districtType = setup.districtType;
                    }
                    if (setup.schoolNumber) {
                        this.schoolNumber = setup.schoolNumber;
                    }

                    // if (setup.orgID) {
                    //  // TODO
                    // }
                },

                OrgIDMethods: {
                    /** output a WebFOCUS-style Org ID.
                     * @memberof OrgID.prototype
                     * @returns {String} A WebFOCUS Org ID
                     * */
                    toWFOrgID: function () {
                        return (_s.pad(this.districtNumber, 4, "0") +
                            _s.pad(this.districtType, 2, "0") +
                            _s.pad(this.schoolNumber, 3, "0"));
                    },
                    /** get a plain JS object that represents the OrgID.
                     * @returns {Object} a plain JS object that represents the OrgID.
                     * @memberof OrgID.prototype */
                    toObject: function () {
                        return {
                            wfOrgID: this.toWFOrgID(),
                            districtNumber: this.districtNumber,
                            districtType: this.districtType,
                            schoolNumber: this.schoolNumber
                        };
                    },

                    // TODO: a proper toString() method that calls a clean
                    // toOrgID() method to output the now-standard MDE
                    // "formatted" orgID

                    /** takes a WebFOCUS Org ID and parses it, setting internal
                     * values correctly
                     * @param {String} wfOrgID A WebFOCUS Org ID
                     * @memberof OrgID.prototype */
                    parseWFOrgID: function (wfOrgID) {
                        // OPTIMIZATION: use substring intead of regex
                        // var re = /^(\d{4})(\d{2})(\d{3})/,
                        //  partsArray = re.exec(qs);
                        var partsArray = [
                            wfOrgID.substring(0, 9),
                            wfOrgID.substring(0, 4),
                            wfOrgID.substring(4, 6),
                            wfOrgID.substring(6, 9)
                        ];

                        if (partsArray) {
                            this.districtNumber = partsArray[1];
                            this.districtType = partsArray[2];
                            this.schoolNumber = partsArray[3];
                        } else {
                            throw "Invalid wfOrgID";
                        }
                    }
                },
                /** @deprecated: don't know where this is necessary. it was called
                 * from getCleanDataView(), but now we can't find why. */
                flattenModelsAndCollections: function (thing) {
                    var flatThing;

                    // if it's a backbone thing, we can use Backbone's toJSON() to
                    // flatten it right away
                    if (_.isFunction(thing.toJSON)) {
                        flatThing = thing.toJSON();
                    } else {
                        flatThing = thing;
                    }

                    // then, go over it and flatten out any child backbone things
                    if (_.isArray(flatThing)) {
                        flatThing = _(flatThing).map(function (subThing) {
                            return this.flattenModelsAndCollections(subThing);
                        }, this).value();
                    } else if (_.isObject(flatThing)) {
                        var keys = _.keys(flatThing),
                            values = _.values(flatThing),
                            newValues;
                        newValues = _(values).map(function (subThing) {
                            return this.flattenModelsAndCollections(subThing);
                        }, this).value();
                        flatThing = _(keys).object(newValues).value();
                    }
                    return flatThing;
                },
                /** tells you if an array is a sequence of numbers or not.
                 * @param {Array} array an array of simple numbers
                 * @returns {Boolean} whether the array is a sequence */
                isSequence: function (array) {
                    var sequential = true,
                        lastNum;

                    if (array.length === 1) {
                        return false;
                    }

                    _(array).each(function (num, index) {
                        if (index > 0) {
                            lastNum = array[index - 1];
                            sequential = sequential && (num === lastNum + 1);
                        }
                    });

                    return sequential;
                },
                /** takes a bitmask in the form of a plain old base ten number, and
                 * spits out an array of numbers, each of which is a zero-based
                 * index of a one in the bitmask. we use this to pack pane
                 * visibility state into URLs with a single digit.
                 * @param {Number | String} baseTen - a big-endian bitmask as a base
                 * ten number
                 * @returns {Array} an array of numbers, each of which is the
                 * zero-based index of a pane that should be in its open state
                 */
                bitmaskToPositionArray: function (bigEndianBitmask, radix) {
                    // we use base 16 by default
                    if (typeof bigEndianBitmask === "string") {
                        bigEndianBitmask = parseInt(bigEndianBitmask, radix || 16);
                    }

                    var bigEndianBitString = bigEndianBitmask.toString(2),
                        bitArray = bigEndianBitString.split(""),
                        openPanesArray = [];

                    // make it little-endian
                    bitArray.reverse();

                    _(bitArray).each(function (singleBitAsString, index) {
                        if (singleBitAsString === "1") {
                            openPanesArray.push(index);
                        }
                    });

                    return openPanesArray;
                },
                /** takes a position array, with numbers marking just the position
                 * of ones in a bitmask, and treating it as a big-endian binary
                 * number, converts it to its base-n representation
                 * @param {Array} array - an array containing the positions of ones
                 * in the bitmask
                 * @param {Number} radix - the numeric base of the string to
                 * produce; 16 (hex) by default
                 * @returns {String} the base-n string version of the bitmask
                 * produced by the given array
                 */
                positionArrayToBitmask: function (array, radix) {
                    if (!array || !array.length) {
                        return "0";
                    }

                    var max = _.max(array),
                        bitmaskString = _s.pad("", max + 1, "0"),
                        leBitmaskCharArray = bitmaskString.split("");

                    _(array).each(function (i) {
                        leBitmaskCharArray[i] = "1";
                    });

                    // make it big-endian (prior to conversion to a different-base
                    // number) and convert it to a string
                    bitmaskString = leBitmaskCharArray.reverse().join("");

                    return parseInt(bitmaskString, 2).toString(radix || 16);
                },
                /** given two objects, determine if any parameters present in both
                 * of them are different.
                 * @param {Object} obj1 - the first object
                 * @param {Object} obj2 - the seconf object
                 * @returns {Boolean} whether there's a difference between any two
                 * shared key/value pairs*/
                paramsAreDifferent: function (obj1, obj2) {
                    return !_.isEqual(obj1, obj2);
                }
            },

            /** @namespace */
            Color: {
                /**
                 * method: construct a single gradient object in HighCharts' format
                 * from our color objects
                 * @static
                 * @returns {Object}
                 */
                makeGradient: function (color) {
                    return {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 1,
                            y2: 0
                        },
                        stops: [[0, color.dark], [0.5, color.light], [1, color.dark]]
                    };
                },
                makeRadialGradient: function (color) {
                    return {
                        radialGradient: {
                            cx: 0.5,
                            cy: 0.5,
                            r: 0.7
                        },
                        stops: [[0, color.light], [0.5, color.medium], [1, color.dark]]
                    };
                },
                /** given a chart type, return a referece to the correct palette.
                 * @param {String} the chart type
                 * @returns {Object} the hash of color or gradient objects */
                palleteForChartType: function (type) {
                    if (type === "line") {
                        return Colors;
                    } else if (type === "pie") {
                        return Util.Color.radialGradients;
                    } else {
                        return Util.Color.gradients;
                    }
                },
                /** given a chart type and color name, return a single
                 * color/gradient object.
                 * @param {String} the chart type
                 * @param {String} the color name requested
                 * @returns {Object} a single color or gradient object */
                colorForChartType: function (type, hueName, shadeName) {
                    var palette = Util.Color.palleteForChartType(type),
                        colorObject = palette[hueName];

                    if (Util.Color.isGradientPalette(palette)) {
                        return colorObject;
                    } else {
                        if (!shadeName) {
                            shadeName = "medium";
                        }
                        return colorObject[shadeName];
                    }
                },
                /** given a chart type, return the proper color/gradient set.
                 * @param {String} the chart type
                 * @returns {Array} the array of color or gradient objects */
                colorArrayForChartType: function (type) {
                    if (type === "line") {
                        return Util.Color.defaultColorSet;
                    } else if (type === "pie") {
                        return Util.Color.defaultRadialGradientSet;
                    } else {
                        return Util.Color.defaultGradientSet;
                    }
                },
                isGradientPalette: function (palette) {
                    if (palette === Colors) {
                        return false;
                    }
                    return true;
                },
                // we need to build gradients programmatically, so we do 'em below.
                gradients: null
            },

            Plugins: {
                recordAliases: function (exports) {
                    _(exports.plugins).each(function (pluginObj, pluginName) {
                        // construct a master list of aliases. each plugin can have
                        // a list of its own.
                        _(pluginObj.aliases).each(function (aliasName) {
                            exports.aliases[aliasName] = pluginName;
                        });
                    });
                }
            },

            // ERROR HANDLING
            globallyIndicateError: function (errorObject) {
                if (!errorObject) {
                    return;
                }

                // I know, this should be in a view or something. Whatever.
                if ($("html").is(".notReady")) {
                    // we show this on the loading screen.
                    window.loadingSpinner.stop();
                    $("#pageLoadingSpinnerBox").hide();
                    $("#loading > .message").html(errorObject.header);
                    $("#loading > .error").html(errorObject.message);
                }
            },
            reportPromiseException: function (error) {
                if (error instanceof Error) {
                    console.log("ERROR in promise callback at " + error.fileName + "@" + error.lineNumber + ": " + error.message);

                    if ((error.message.indexOf("unmaskForLoading") > -1)) {
                       if(location.hash.indexOf("mySchool") > -1)
                            location.href = location.origin;
                        setTimeout(function () {
                            location.reload(true);
                        }, 500);
                    }
                    console.log("Stack trace:");
                    console.log(error.stack);
                    console.log(error);
                }
                return error;
            }
        };

        // calculate gradients
        Util.Color.gradients = {
            orange: Util.Color.makeGradient(Colors.orange),
            purple: Util.Color.makeGradient(Colors.purple),
            red: Util.Color.makeGradient(Colors.red),
            green: Util.Color.makeGradient(Colors.green),
            green2: Util.Color.makeGradient(Colors.green2),
            yellow: Util.Color.makeGradient(Colors.yellow),
            cream: Util.Color.makeGradient(Colors.cream),
            blue1: Util.Color.makeGradient(Colors.blue1),
            blue2: Util.Color.makeGradient(Colors.blue2),
            blue3: Util.Color.makeGradient(Colors.blue3),
            blue4: Util.Color.makeGradient(Colors.blue4),
            brown: Util.Color.makeGradient(Colors.brown),
            magenta: Util.Color.makeGradient(Colors.magenta),
            grey: Util.Color.makeGradient(Colors.grey),
            grey2: Util.Color.makeGradient(Colors.grey2),
            gold: Util.Color.makeGradient(Colors.gold)

        };

        Util.Color.radialGradients = {
            orange: Util.Color.makeRadialGradient(Colors.orange),
            purple: Util.Color.makeRadialGradient(Colors.purple),
            green: Util.Color.makeRadialGradient(Colors.green),
            green2: Util.Color.makeRadialGradient(Colors.green2),
            cream: Util.Color.makeRadialGradient(Colors.cream),
            blue1: Util.Color.makeRadialGradient(Colors.blue1),
            yellow: Util.Color.makeRadialGradient(Colors.yellow),
            red: Util.Color.makeRadialGradient(Colors.red),
            blue2: Util.Color.makeRadialGradient(Colors.blue2),
            blue3: Util.Color.makeRadialGradient(Colors.blue3),
            blue4: Util.Color.makeGradient(Colors.blue4),
            grey: Util.Color.makeRadialGradient(Colors.grey),
            gold: Util.Color.makeRadialGradient(Colors.gold),
            grey2: Util.Color.makeRadialGradient(Colors.grey2)
        };

        // set up colors and gradients
        (function () {
            var gradients = Util.Color.gradients,
                radialGradients = Util.Color.radialGradients,
                colors = Colors;

            Util.Color.defaultGradientSet = [
                gradients.blue1,
                gradients.green,
                gradients.blue2,
                gradients.grey2,
                gradients.purple,
                gradients.gold,
                gradients.blue3,
                gradients.cream,
                gradients.blue4,
                gradients.green2,
                gradients.orange,
                gradients.grey
            ];
            Util.Color.defaultColorSet = [
                colors.blue1.medium,
                colors.green.medium,
                colors.blue2.medium,
                colors.grey2.medium,
                colors.purple.medium,
                colors.gold.medium,
                colors.blue3.medium,
                colors.cream.medium,
                colors.blue4.medium,
                colors.green2.medium,
                colors.orange.medium,
                colors.grey.medium
            ];
            Util.Color.defaultRadialGradientSet = [
                radialGradients.blue1,
                radialGradients.green,
                radialGradients.blue2,
                radialGradients.grey2,
                radialGradients.purple,
                radialGradients.gold,
                radialGradients.blue3,
                radialGradients.cream,
                radialGradients.blue4,
                radialGradients.green2,
                radialGradients.orange,
                radialGradients.grey
            ];

            Util.Color.defaultGradientSet.isGradient = true;
            Util.Color.defaultRadialGradientSet.isGradient = true;
            Util.Color.defaultColorSet.isGradient = false;
        })();

        // set up OrgID object prototype
        Util.Data.OrgID.prototype = Util.Data.OrgIDMethods;

        // Douglas Crockford's prototypal object inheritance pattern
        // this is implemented natively in all but IE<9
        // use it like:
        // var newObject = Object.create(oldObject);

        if (typeof Object.create !== "function") {
            Object.create = function (o) {
                function F() { }
                F.prototype = o;
                return new F();
            };
        }

        // from https://github.com/hongymagic/jQuery.serializeObject/blob/master/jquery.serializeObject.js
        //
        // Use internal $.serializeArray to get list of form elements which is
        // consistent with $.serialize
        //
        // From version 2.0.0, $.serializeObject will stop converting [name] values
        // to camelCase format. This is *consistent* with other serialize methods:
        //
        // - $.serialize
        // - $.serializeArray
        //
        // If you require camel casing, you can either download version 1.0.4 or map
        // them yourself.
        //

        (function ($) {
            $.fn.serializeObject = function () {
                "use strict";

                var result = {};
                var extend = function (i, element) {
                    var node = result[element.name];

                    // If node with same name exists already, need to convert it to an array as it
                    // is a multi-value field (i.e., checkboxes)

                    if ("undefined" !== typeof node && node !== null) {
                        if ($.isArray(node)) {
                            node.push(element.value);
                        } else {
                            result[element.name] = [node, element.value];
                        }
                    } else {
                        result[element.name] = element.value;
                    }
                };

                $.each(this.serializeArray(), extend);
                return result;
            };
        })(jQuery);

        (function ($, window) {

            var intervals = {};
            var removeListener = function (selector) {

                if (intervals[selector]) {

                    window.clearInterval(intervals[selector]);
                    intervals[selector] = null;
                }
            };
            var found = 'waitUntilExists.found';

            /**
             * @function
             * @property {object} jQuery plugin which runs handler function once specified
             *           element is inserted into the DOM
             * @param {function|string} handler 
             *            A function to execute at the time when the element is inserted or 
             *            string "remove" to remove the listener from the given selector
             * @param {bool} shouldRunHandlerOnce 
             *            Optional: if true, handler is unbound after its first invocation
             * @example jQuery(selector).waitUntilExists(function);
             */

            $.fn.waitUntilExists = function (handler, shouldRunHandlerOnce, isChild) {

                var selector = this.selector;
                var $this = $(selector);
                var $elements = $this.not(function () { return $(this).data(found); });

                if (handler === 'remove') {

                    // Hijack and remove interval immediately if the code requests
                    removeListener(selector);
                }
                else {

                    // Run the handler on all found elements and mark as found
                    $elements.each(handler).data(found, true);

                    if (shouldRunHandlerOnce && $this.length) {

                        // Element was found, implying the handler already ran for all 
                        // matched elements
                        removeListener(selector);
                    }
                    else if (!isChild) {

                        // If this is a recurring search or if the target has not yet been 
                        // found, create an interval to continue searching for the target
                        intervals[selector] = window.setInterval(function () {

                            $this.waitUntilExists(handler, shouldRunHandlerOnce, true);
                        }, 500);
                    }
                }

                return $this;
            };

        }(jQuery, window));

        return Util;
    });
